import { getYMDAndTimeFormatDate } from 'utils/getCustomFormatDate';
import { fnComparedValueAndCriterion } from 'utils/logProcessing';

export default function makeDataLevel(d, gasCriterion, pageIndex, pageSize, index) {
  console.log(d)
  return {
    rnum: pageIndex * pageSize + index + 1,
    modelNm: d.module?.modelNm ?? '미확인장치',
    areaNo: d.locationNo,
    areaNm: d.locationNm,
    
    temp: d.temp?.toFixed(1) ?? 'N/A',
    humi: d.humi,
    heatindex: d.heatindex?.toFixed(1) ?? 'N/A',

    seqnum: d.seqnum,
    rssi: d.rssi,

    sf: d.sf,
    freqeuncy: d.freqeuncy,
    snr: d.snr,
    statusCode: d.statusCode,
    relayFlag: d.relayFlag,
    status: fnComparedValueAndCriterion(d, d.module.moduleScn, gasCriterion)[0],

    battery: d.battery,
    regTime: d.rgstDt ? getYMDAndTimeFormatDate(new Date(d.rgstDt)) : 'N/A',
  };
}
